import { DashboardMetricSet } from '../dashboard-metric';
import { DashboardEventService } from '../dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-metric-content-placeholder',
    templateUrl: './dashboard-metric-content-placeholder.component.html',
    styleUrls: ['./dashboard-metric.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DashboardMetricContentPlaceholderComponent implements OnInit {
    @Input()
    dashboardMetricSet: DashboardMetricSet;

    constructor(private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
    }
}
